module.exports = __webpack_public_path__ + "static/metrics-dashboard-5fed534b523bf124417a53b5bc22766c.png";